export const saveToken = (payload = {}) => {
  window.localStorage.setItem('tokenData', JSON.stringify(payload));
};

export const getToken = () => {
  return window.localStorage.getItem('tokenData');
};

export const deleteToken = () => {
  window.localStorage.removeItem('tokenData');
};

export const isAuthenticated = () => getToken() !== null;

export const getEnv = () => {
  return 'PROD';
}

